<template>
  <div v-if="showNotCertifi" class='not-certified flexCenter'>
    <div class="model">
      <div class="logo"><span>IBAYPAY</span> TECH</div>
        <div v-if="status === 'not_submitted' || status === 'reject'">
          <div class="message">
            {{isLanguage==='English'?'You have not completed the enterprise certification,Multi-currency wallet':'您当前尚未完成进行企业认证，'}}<br/>
            {{isLanguage==='English'?'Please submit the enterprise certification materials as soon as possible!':'请尽快提交企业认证资料!'}}
          </div>
          <el-button class="goCertifi" @click="goCertifi">{{isLanguage==='English'?'Submit enterprise certification materials':'提交企业认证资料'}}</el-button>
        </div>
        <div v-if="status === 'pending'">
          <div class="message" v-if="status === 'pending'">
            {{isLanguage==='English'?'Your data is being reviewed, please wait patiently~':'您的资料正在审核中，请耐心等待～'}}
          </div>
          <el-button class="goCertifi" @click="closeModel">{{isLanguage==='English'?' I see':'我知道了'}}</el-button>
        </div>
      <i class="el-icon-error" @click="closeModel" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getLanguage } from '@/utils/auth'
export default {
  name: 'notCertified',
  props: {
    showNotCertifi: {
      type: Boolean,
      required: true,
    }
  },
  computed: {
    ...mapState({
      status: state => state.user.status
    }),
  },
  data(){
    return {
      isLanguage:getLanguage()
    }
  },
  components: {},
  created(){},
  mounted(){},
  methods: {
    goCertifi() {
      this.$router.push('/enterpriseCertification')
      this.$emit('closeModel')
    },
    closeModel() {
      this.$emit('closeModel')
    }
  }
}
</script>
<style lang='scss' scoped>
.not-certified {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  z-index: 2000;
  .model {
    width: 580px;
    // height: 350px;
    padding: 30px 40px 60px;
    background:rgba(255,255,255,1);
    box-shadow:0px 4px 20px 0px rgba(0,0,0,0.1);
    border-radius:20px;
    position: relative;
    .logo {
      color: #006EFF;
      span {
        font-weight: bold;
      }
    }
    .message {
      margin: 56px 0 40px;
      font-size: 20px;
      font-weight: 400;
      color: rgba(128,130,147,1);
      line-height: 32px;
      text-align: center;
    }
    .goCertifi {
      background: rgba(24,204,147,1);
      font-size: 14px;
      font-weight: 600;
      color: rgba(255,255,255,1);
      line-height: 24px;
      margin-left: 50%;
      transform: translateX(-50%);
      cursor: pointer;
    }
    .el-icon-error{
      position: absolute;
      top: 20px;
      right: 20px;
      color: #E8E8EB;
      border: none;
      cursor: pointer;
    }
  }
}
</style>
